import(/* webpackMode: "eager" */ "/app/app/[locale]/(app)/(withSidebar)/spot/not-supported-landscape.tsx");
import(/* webpackMode: "eager" */ "/app/app/[locale]/(app)/(withSidebar)/spot/spot.module.css")